<template>
    <div v-if="!state.loading">
    <div class="pgehd">
        <h2>{{ state.title }}</h2>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>
        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="teacher" header="Teacher" />
        <PrimeColumn field="subject" header="Subject" />
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRoute } from "vue-router";

export default {
  setup(){
    const route = useRoute();
    const id = computed(() => route.params.id)
    const state=reactive({loading:true, title:"Student Teachers"});
    const list = ref([])
    function setTable(d){
        if (!Array.isArray(d)) {
            list.value = Object.values(d)
        } else {
            list.value = d
        }
    }

    onMounted(() => {
        call({
            url:urls.students,
            data:{getTeachersList:id.value},
            success:(res)=>{
                state.loading=false
                if(res.status){
                    setTable(res.msg.list)
                    state.title=res.msg.title;
                }else{
                    alert(res.msg);
                }
            }
        })
    });

    return {
      state,list
    }
  }
}

</script>